import * as React from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverContent = React.forwardRef(
  ({ className, ...props }, ref) => (
    <PopoverPrimitive.Content
      ref={ref}
      className={`z-50 rounded-3xl border border-gray-500 bg-white p-4 shadow-md outline-none ${className}`}
      {...props}
    />
  )
);

PopoverContent.displayName = "PopoverContent";
